// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__10Fv3","error":"Alert_error__329yr","success":"Alert_success__Jv2Jc","info":"Alert_info__KJNVN","warning":"Alert_warning__HN6yP"};